import React from 'react'

// css
import 'assets/style/components/bottom-button.scss'
import 'assets/style/elements/button.scss'

// elements
import IconButton from 'components/elements/IconButton'
import arrowUpIcon from './../../assets/images/icon/2x/icon-dot-white.svg'

function Element({ className, data = [], refresh = false, onClick = () => {}, onRefresh = () => {} }) {
  return (
    <section className={'bottom-button-area ' + className}>
      {refresh && <IconButton type="refresh" onClick={() => onRefresh(refresh)} size={64} />}
      {data.map((item, index) => (
        <button
          type="button"
          className={`btn ${[item.color, item.size].join(' ')} full`}
          onClick={() => {
            onClick(item)
          }}
          key={`button_${index}`}
          style={item?.style}
        >
          {item?.id === 'goupStock' ? (
            <img src={arrowUpIcon} alt={item.title} style={{ width: '20px', margin: '0 4px' }} />
          ) : (
            item.title
          )}
        </button>
      ))}
    </section>
  )
}

export default Element
